module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-27.bc3076ad.png";